import React, { useState, useEffect, useContext } from 'react';
import { MenuContext } from 'src/context/MenuContext';
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import Header from 'src/components/common/Header';
import ClientTable from 'src/components/client/ClientTable';
import { getClients } from "src/store/client";
import Menu from 'src/components/common/Menu';
import ScrollTop from 'src/components/common/ScrollTop';
import CustomLoader from 'src/components/common/CustomLoader';
import { ValidationMessages } from 'src/components/common/ValidationMessage';

const ClientList = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const client = useSelector((state) => state.client);
  const [loading, setLoading] = useState(true);
  const [validationMessages, setValidationMessages] = useState([]);
  

  const [cd, setCd] = useState('');

  const clientInput = () => {
    navigate('/clientInput');
  };

  useEffect(() => {
    dispatch(
      getClients({
        status_cd: cd
      })
    ).then((response) => {
      if (response.payload?.errors) {
        setValidationMessages(response.payload.errors)
      }
      if(response.error){
        setValidationMessages(response.error.message);
      }
      if(response.payload){
        setLoading(false);
      }
    })
  }, [dispatch, cd])


  // Destructuring correctly from menuContext
  const { visibleMenu } = useContext(MenuContext);

  return (
    <>
      {visibleMenu && <Menu />}
      <div className={visibleMenu ? 'menu-open' : 'menu-closed'}>
        <Header sx={{ mb: 500 }} />
        <div id="client_list">
          {validationMessages && validationMessages.length > 0 && (
              <div style={{ background: "#ffe4e2" }}>
                  <ValidationMessages
                      messages={validationMessages}
                      onClose={() => setValidationMessages([])}
                  />
              </div>
          )}
          <section className="container-fluid contents-top">
            <div className="text-center">
              <h1>
                Client List ({client.total} People)&nbsp;
                <button
                  type="button"
                  className="btn btn-default"
                  onClick={clientInput}
                >
                  <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                </button>
              </h1>
            </div>
          </section>
          {loading ? <CustomLoader /> : 
            <section className="container">
              <div>
                <ClientTable clients={client.data} cd={cd} setCd={setCd} />
              </div>
            </section>
          }
        </div>
      </div>
      <ScrollTop />
    </>
  );
};

export default ClientList;
